<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>{{
            $t("info_card.education_background_undergrad")
          }}</v-card-title>
          <v-divider color="white"></v-divider>
          <EducationBackgroundUndergradCard
            :value_schoolLocation="EducationBGUndergrad_schoolLocation"
            @input_schoolLocation="EducationBGUndergrad_schoolLocation = $event"
            :value_countryIdOfSchool="EducationBGUndergrad_countryIdOfSchool"
            @input_countryIdOfSchool="
              EducationBGUndergrad_countryIdOfSchool = $event
            "
            :value_schoolName="EducationBGUndergrad_schoolName"
            @input_schoolName="EducationBGUndergrad_schoolName = $event"
            :value_provinceIdOfSchool="EducationBGUndergrad_provinceIdOfSchool"
            @input_provinceIdOfSchool="
              EducationBGUndergrad_provinceIdOfSchool = $event
            "
            :value_schoolId="EducationBGUndergrad_schoolId"
            @input_schoolId="EducationBGUndergrad_schoolId = $event"
            :value_schoolTypeId="EducationBGUndergrad_schoolTypeId"
            @input_schoolTypeId="EducationBGUndergrad_schoolTypeId = $event"
            :value_educationTypeId="EducationBGUndergrad_educationTypeId"
            @input_educationTypeId="
              EducationBGUndergrad_educationTypeId = $event
            "
            :value_educationOther="EducationBGUndergrad_educationOther"
            @input_educationOther="
              EducationBGUndergrad_educationOther = $event
            "
            :value_studyStatusId="EducationBGUndergrad_studyStatusId"
            @input_studyStatusId="EducationBGUndergrad_studyStatusId = $event"
            :value_studyTypeId="EducationBGUndergrad_studyTypeId"
            @input_studyTypeId="EducationBGUndergrad_studyTypeId = $event"
            :value_termOfGpa="EducationBGUndergrad_termOfGpa"
            @input_termOfGpa="EducationBGUndergrad_termOfGpa = $event"
            :value_GPA="EducationBGUndergrad_GPA"
            @input_GPA="EducationBGUndergrad_GPA = $event"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validator from "@/helper/validator";

import EducationBackgroundUndergradCard from "@/components/info_cards/EducationBackgroundUndergrad";
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ApplicantInfoSchool",
  data: function() {
    return {
      form_validate_status: null,

      EducationBGUndergrad_schoolLocation: "inThai",
      EducationBGUndergrad_countryIdOfSchool: null,
      EducationBGUndergrad_schoolName: null,
      EducationBGUndergrad_provinceIdOfSchool: null,
      EducationBGUndergrad_schoolId: null,

      EducationBGUndergrad_schoolTypeId: null,
      EducationBGUndergrad_educationTypeId: null,
      EducationBGUndergrad_educationOther: null,
      EducationBGUndergrad_studyStatusId: null,
      EducationBGUndergrad_studyTypeId: null,
      EducationBGUndergrad_termOfGpa: null,
      EducationBGUndergrad_GPA: null,

      requiredRules: [validator.required],
    };
  },
  components: {
    EducationBackgroundUndergradCard,
  },

  methods: {
    async fetch_data() {
      await this.$store.dispatch("auth/getSidebarStatus");
      const data = await applicantInfoService.getApplicantInfoSchool();

      if (data.COUNTRY_ID_OF_SCHOOL === "TH") {
        this.EducationBGUndergrad_schoolLocation = "inThai";
      } else if (data.COUNTRY_ID_OF_SCHOOL === "XX") {
        //กรณีที่เลือก GED ให้ที่ตั้งประเทศเป็น อื่นๆ (XX)
        this.EducationBGUndergrad_schoolLocation = "other";
      } else if (
        data.COUNTRY_ID_OF_SCHOOL &&
        data.COUNTRY_ID_OF_SCHOOL.length === 2
      ) {
        this.EducationBGUndergrad_schoolLocation = "foreignCountry";
      }
      this.EducationBGUndergrad_countryIdOfSchool = data.COUNTRY_ID_OF_SCHOOL;
      this.EducationBGUndergrad_schoolName = data.SCHOOL_NAME;
      this.EducationBGUndergrad_provinceIdOfSchool = data.SCHOOL_PROVINCE_ID;
      this.EducationBGUndergrad_schoolId = data.SCHOOL_ID;

      this.EducationBGUndergrad_schoolTypeId = data.SCHOOL_TYPE_ID;
      this.EducationBGUndergrad_educationTypeId = data.EDUCATION_TYPE_ID;
      this.EducationBGUndergrad_educationOther = data.EDUCATION_OTHER;
      this.EducationBGUndergrad_studyStatusId = data.STUDY_STATUS_ID;
      this.EducationBGUndergrad_studyTypeId = data.STUDY_TYPE_ID;
      this.EducationBGUndergrad_termOfGpa = data.TERM_OF_GPA;
      this.EducationBGUndergrad_GPA = data.GPA;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      await this.$store.dispatch("auth/getSidebarStatus");
      const response = await applicantInfoService
        .setApplicantInfoSchool({
          COUNTRY_ID_OF_SCHOOL:
            this.EducationBGUndergrad_schoolLocation === "inThai"
              ? "TH"
              : this.EducationBGUndergrad_schoolLocation === "other"
              ? "XX"
              : this.EducationBGUndergrad_countryIdOfSchool,
          SCHOOL_NAME:
            this.EducationBGUndergrad_schoolLocation === "inThai"
              ? ""
              : this.EducationBGUndergrad_schoolName,
          SCHOOL_ID:
            this.EducationBGUndergrad_schoolLocation === "inThai"
              ? this.EducationBGUndergrad_schoolId
              : "",
          SCHOOL_TYPE_ID: this.EducationBGUndergrad_schoolTypeId,
          EDUCATION_TYPE_ID: this.EducationBGUndergrad_educationTypeId,
          EDUCATION_OTHER: this.EducationBGUndergrad_educationOther,
          STUDY_STATUS_ID: this.EducationBGUndergrad_studyStatusId,
          STUDY_TYPE_ID: this.EducationBGUndergrad_studyTypeId,
          TERM_OF_GPA: this.EducationBGUndergrad_termOfGpa,
          GPA: this.EducationBGUndergrad_GPA,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
